/**
 * Superficie de las tarjetas propias del modal de verificación: las fases que
 * no son del SDK, el aviso de trámite nuevo y la carga/error del SDK. Radio 24
 * → `rounded-3xl`.
 */
export const PANEL_VERIFICATION_CARD_CLASSES =
  'overflow-hidden rounded-3xl bg-surface shadow-standard';
